export function isLogin() {
    const isLogin = localStorage.getItem('cicekToken') ? true : false;
	return isLogin;
}
